module.exports = __webpack_public_path__ + "img/standard_1.e1808f37.png";